// Paddle.js checkout integration

import type { CheckoutConfig, PaddleConfig } from '../types';

declare global {
  interface Window {
    Paddle: any;
  }
}

let initialized = false;

function ensureInitialized(clientToken: string, environment: string): boolean {
  if (!window.Paddle) {
    alert('Paddle checkout is not available. Please refresh the page and try again.');
    return false;
  }

  if (!initialized) {
    if (environment === 'sandbox') {
      window.Paddle.Environment.set('sandbox');
    }
    window.Paddle.Initialize({ token: clientToken });
    initialized = true;
  }

  return true;
}

/**
 * Open checkout for resubscribing (existing customer with license_set_id)
 */
export function openCheckout(config: CheckoutConfig, onSuccess: () => void): void {
  if (!ensureInitialized(config.clientToken, config.environment)) return;

  window.Paddle.Checkout.open({
    items: [{ priceId: config.priceId }],
    customer: { email: config.customerEmail },
    customData: { licenseSetId: config.licenseSetId },
    settings: {
      displayMode: 'overlay',
      theme: 'dark',
      successUrl: window.location.href,
    },
    successCallback: () => {
      onSuccess();
    },
  });
}

/**
 * Open checkout for new customers (no license_set_id)
 */
export function openNewCustomerCheckout(config: PaddleConfig, email?: string): void {
  if (!ensureInitialized(config.clientToken, config.environment)) return;

  const checkoutOptions: any = {
    items: [{ priceId: config.priceId, quantity: 1 }],
    settings: {
      displayMode: 'overlay',
      theme: 'dark',
    },
  };

  if (email) {
    checkoutOptions.customer = { email };
  }

  window.Paddle.Checkout.open(checkoutOptions);
}
